module.exports = __webpack_public_path__ + "img/足部诊疗康复.177b184b.png";